import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo } from 'react';
const defaultProps = {
    loading: false,
    text: '',
};
const ButtonText = ({ loading = defaultProps.loading, text = defaultProps.text, }) => (_jsx("span", Object.assign({ css: [
        loading &&
            css `
          visibility: hidden;
        `,
    ] }, { children: text })));
const MemoizedButtonText = memo(ButtonText);
export { MemoizedButtonText as ButtonText };
